import { Component, HostBinding, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SessionCategory, SessionCategoryLabel } from '@oxypeak/commons';

@Component({
  selector: 'oxy-session-category',
  templateUrl: './session-category.component.html',
  styleUrls: ['./session-category.component.scss'],
  imports: [TranslateModule, MatIconModule],
})
export class SessionCategoryComponent {
  @Input() category!: SessionCategory | undefined | 'NEW';
  @Input() button = false;

  @HostBinding('class.button') get isButton() {
    return this.button;
  }

  SessionCategoryLabel = SessionCategoryLabel;
  SessionCategory = SessionCategory;
}
